import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { map } from 'rxjs/operators';

import { environment } from 'src/environments/environment';
import { SortableTable } from './services-table-helper';

@Injectable({
  providedIn: 'root'
})
export class PerformanceTableService extends SortableTable<any> {
  private baseUrl = environment.API_URL;

  performance: any[];
  performanceLength: number;

  constructor(private http: HttpClient) {
    super();
  }

  sortEvent() {
    const tables = this.sort(this.performance, this._state.sortColumn, this._state.sortDirection);
    this._tables$.next(tables);
  }

  getPerformanceAPI(obj) {
    return this.http.post(
      `${this.baseUrl}/testarea-performantelor/`,
      {
        ...obj,
      }
    ).pipe(map((response: any) => {
      this.performance = response.result;
      this.performanceLength = response.count;

      this.paginate();
      this.sortEvent();
      this._total$.next(this.performanceLength);

      return response;
    }));
  }

  exportXLS(obj) {
    return this.http
    .post(
      `${this.baseUrl}/testarea-performantelor/export/`,
      {
        ...obj
      },
      {
        responseType: 'blob'
      }
    ).pipe(map((response: any) => {
      return response;
    }));
  }

  getAcbcrRacesAPI() {
    return this.http
      .get(
        `${this.baseUrl}/acbcr-race/`
      ).pipe(map((response: any) => {
        return response;
      }));
  }

  /**
   * Paginate Method
   */
  private paginate(): void {
    this.totalRecords = this.performanceLength;
    this._state.startIndex = (this._state.page - 1) * this.pageSize + 1;
    this._state.endIndex = Number(this.pageSize) + Number(this._state.startIndex - 1);

    if (this._state.endIndex > this.performanceLength) {
      this._state.endIndex = this.performanceLength;
    }
  }

}
